import Theme from '@adsk/alloy-react-theme';

export const checkboxStyle = {
  marginRight: '8px',
};

export const accessStyle = (disabled) => ({
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
  ...(disabled && {
    color: Theme.colors.charcoal500,
  }),
});
